// extracted by mini-css-extract-plugin
module.exports = {"listAction":"SideMenus_listAction_2TLyW"};